// UI STATES
const MODULE_NAME = 'fulcrum/container/Product/ModifySpecifications'
const UPDATE_SPECIFICATIONS = 'fulcrum/container/Product/ModifySpecifications/UPDATE_SPECIFICATIONS'
const UPDATE_IMPORT_SKUS_LIST = 'fulcrum/container/Product/ModifySpecifications/UPDATE_IMPORT_SKUS_LIST'
const UPDATE_SPEC_SOURCES = 'fulcrum/container/Product/ModifySpecifications/UPDATE_SECTION_HEADERS'
const CHANGE_EDIT_VALUE = 'fulcrum/container/Product/ModifySpecifications/CHANGE_EDIT_VALUE'
const UPDATE_EDIT_VALUE = 'fulcrum/container/Product/ModifySpecifications/UPDATE_EDIT_VALUE'
const UPDATE_SELECTED_REVISION = 'fulcrum/container/Product/ModifySpecifications/UPDATE_SELECTED_REVISION'
const CLEAR_EDIT_VALUE = 'fulcrum/container/Product/ModifySpecifications/CLEAR_EDIT_VALUE'
const TOGGLE_REVISION_DIALOG = 'fulcrum/container/Product/ModifySpecifications/TOGGLE_REVISION_DIALOG'
const TOGGLE_IMPORT_DIALOG = 'fulcrum/container/Product/ModifySpecifications/TOGGLE_IMPORT_DIALOG'
const TOGGLE_HIDE_SPECIFICATIONS_TABLE = 'fulcrum/container/Product/ModifySpecifications/TOGGLE_HIDE_SPECIFICATIONS_TABLE'

const FETCH_SPECIFICATIONS = 'fulcrum/container/Product/ModifySpecifications/FETCH_SPECIFICATIONS'
const FETCH_SPECIFICATIONS_START = 'fulcrum/container/Product/ModifySpecifications/FETCH_SPECIFICATIONS_START'
const FETCH_SPECIFICATIONS_SUCCESS = 'fulcrum/container/Product/ModifySpecifications/FETCH_SPECIFICATIONS_SUCCESS'
const FETCH_SPECIFICATIONS_ERROR = 'fulcrum/container/Product/ModifySpecifications/FETCH_SPECIFICATIONS_ERROR'

const IMPORT_SPECIFICATIONS_SUMMARY = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATIONS_SUMMARY'
const IMPORT_SPECIFICATIONS_SUMMARY_START = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATIONS_SUMMARY_START'
const IMPORT_SPECIFICATIONS_SUMMARY_SUCCESS = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATIONS_SUMMARY_SUCCESS'
const IMPORT_SPECIFICATIONS_SUMMARY_ERROR = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATIONS_SUMMARY_ERROR'

const IMPORT_SPECIFICATION = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATION'
const IMPORT_SPECIFICATION_START = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATION_START'
const IMPORT_SPECIFICATION_SUCCESS = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATION_SUCCESS'
const IMPORT_SPECIFICATION_ERROR = 'fulcrum/container/Product/ModifySpecifications/IMPORT_SPECIFICATION_ERROR'

const POST_SPECIFICATIONS = 'fulcrum/container/Product/ModifySpecifications/POST_SPECIFICATIONS'
const POST_SPECIFICATIONS_START = 'fulcrum/container/Product/ModifySpecifications/POST_SPECIFICATIONS_START'
const POST_SPECIFICATIONS_SUCCESS = 'fulcrum/container/Product/ModifySpecifications/POST_SPECIFICATIONS_SUCCESS'
const POST_SPECIFICATIONS_ERROR = 'fulcrum/container/Product/ModifySpecifications/POST_SPECIFICATIONS_ERROR'


// Form Constants
const DEFAULT_WIDTH = 7
const DEFAULT_WIDTH_SECTIONS = ['voltageRegulator', 'displayConnector', 'overclock', 'nvLink', 'nvQual', 'pcIe', 'targetApplication', 'defaultCpu', 'defaultSystemInfo']
// horizontal header sections have title fields arranged horizontally across the first row of the section
const HORIZONTAL_HEADERS = ['supportedFeatures', 'overclock', 'memory', 'pcb', 'power', 'baseboard', 'nvLink', 'nvQual', 'thermal', 'formElements', 'mechanical']
// vertical header sections have title fields arranged vertically across the first column of the section
const VERTICAL_HEADERS = ['memory', 'pcb', 'pcIe', 'targetApplication', 'baseboard', 'nvLink', 'nvQual', 'inputConnector', 'power', 'thermal', 'voltageRegulator', 'displayConnector', 'formElements', 'mechanical']
const SECTION_DETAILS = {
  SUPPORTED_FEATURES: {
    key: 'supportedFeatures',
    fields: {
      FEATURE_NAME: 'Feature Name',
      ENABLED: 'Enabled'
    }
  },
  OVERCLOCK: {
    key: 'overclock',
    fields: {
      BASE_CLOCK: 'Baseclock (MHz)',
      BOOST_CLOCK: 'Boost (GPCCLK)',
      OC_BIN: 'OC_BIN'
    }
  },
  MEMORY: {
    key: 'memory',
    fields: {
      PART_NUMBER: 'Part Number',
      VENDOR_NAME: 'Vendor Name',
      ORGANIZATION_SIZE: 'Organization Size',
      ORGANIZATION_WIDTH: 'Organization Width',
      PART_TYPE: 'Part Type',
      RVL: 'RVL',
      CLOCK: 'Clock'
    }
  },
  PCB: {
    key: 'pcb',
    fields: {
      TECHNOLOGY: 'PCB Technology'
    }
  },
  PCIE: {
    key: 'pcIe',
    fields: {
      SPEED: 'Speed',
      WIDTH: 'Width'
    }
  },
  NVLINK: {
    key: 'nvLink',
    fields: {
      TOPOLOGY_TITLE: 'NVLink Topology',
      SPEED_TITLE: 'NVLink Speeds',
      TOPOLOGIES: 'Topologies',
      SPEEDS: 'Speeds',
    }
  },
  TARGET_APPLICATION: {
    key: 'targetApplication',
    fields: {
      APPLICATION: 'Application'
    }
  },
  NVQUAL: {
    key: 'nvQual',
    fields: {
      THERMAL_TITLE: 'Thermal',
      TEST_TYPE: 'Test Type',
    }
  },
  POWER: {
    key: 'power'
  },
  BASEBOARD: {
    key: 'baseboard'
  },
  THERMAL: {
    key: 'thermal'
  },
  FORM_ELEMENTS: {
    key: 'formElements'
  },
  MECHANICAL: {
    key: 'mechanical'
  },
  INPUT_CONNECTOR: {
    key: 'inputConnector',
    fields: {
      CONNECTOR_COUNT: 'Connector Count',
      PIN_COUNT: 'Pin Count'
    }
  },
  VOLTAGE_REGULATOR: {
    key: 'voltageRegulator',
    fields: {
      PART_TYPE: 'Part Type',
      RAIL_TYPE: 'Rail Type',
      PART_NUMBER: 'Part Number',
      PHASE_COUNT: 'Phase Count',
      VENDOR_NAME: 'Vendor Name',
    }
  },
  DISPLAY_CONNECTOR: {
    key: 'displayConnector',
    fields: {
      LINK_TYPE: 'Link Type',
      CONNECTOR_TYPE: 'Connector Type',
      CONNECTOR_LOCATION: 'Connector Location',
      CONNECTOR_BRACKET: 'Connector Bracket',
    }
  },
  DEFAULT_CPU: {
    key: 'defaultCpu',
    fields: {
      ARCHITECTURE: 'Architecture',
      CLASSIFICATION: 'Classification',
      BRAND: 'Brand',
      MODEL_NAME: 'Model Name'
    }
  },
  DEFAULT_SYSTEM_INFO: {
    key: 'defaultSystemInfo',
    fields: {
      GPU_MEMORY_SIZE: 'GPU Memory Size',
      SYSTEM_MEMORY_SIZE: 'System Memory Size',
      BMC_VENDOR_PN: 'BMC Vendor Pn'
    }
  }
}

export {
  // UI States
  MODULE_NAME,
  CHANGE_EDIT_VALUE,
  TOGGLE_REVISION_DIALOG,
  TOGGLE_IMPORT_DIALOG,
  TOGGLE_HIDE_SPECIFICATIONS_TABLE,
  FETCH_SPECIFICATIONS,
  FETCH_SPECIFICATIONS_START,
  FETCH_SPECIFICATIONS_SUCCESS,
  FETCH_SPECIFICATIONS_ERROR,
  UPDATE_SPECIFICATIONS,
  UPDATE_IMPORT_SKUS_LIST,
  UPDATE_SPEC_SOURCES,
  UPDATE_EDIT_VALUE,
  UPDATE_SELECTED_REVISION,
  CLEAR_EDIT_VALUE,
  POST_SPECIFICATIONS,
  POST_SPECIFICATIONS_START,
  POST_SPECIFICATIONS_SUCCESS,
  POST_SPECIFICATIONS_ERROR,
  IMPORT_SPECIFICATIONS_SUMMARY,
  IMPORT_SPECIFICATIONS_SUMMARY_START,
  IMPORT_SPECIFICATIONS_SUMMARY_SUCCESS,
  IMPORT_SPECIFICATIONS_SUMMARY_ERROR,
  IMPORT_SPECIFICATION,
  IMPORT_SPECIFICATION_START,
  IMPORT_SPECIFICATION_SUCCESS,
  IMPORT_SPECIFICATION_ERROR,
  // form fields
  HORIZONTAL_HEADERS,
  VERTICAL_HEADERS,
  DEFAULT_WIDTH,
  DEFAULT_WIDTH_SECTIONS,
  SECTION_DETAILS,
}
